// m:ss under an hour, h:mm:ss from one hour up. Meeting time runs from the
// meeting's start, so a long call's timestamps pass an hour where "85:12" would
// be hard to read.
export function formatTime(seconds: number): string {
  const total = Math.max(0, Math.floor(seconds));
  const h = Math.floor(total / 3600);
  const m = Math.floor(total / 60) % 60;
  const s = total % 60;
  const ss = String(s).padStart(2, "0");
  return h > 0 ? `${h}:${String(m).padStart(2, "0")}:${ss}` : `${m}:${ss}`;
}
